

export const useWebpToPng=()=>{


    const convertWebpToPng = (webpUrl: string): Promise<string> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.src = webpUrl;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            if (ctx) {
              ctx.drawImage(img, 0, 0);
              resolve(canvas.toDataURL("image/png")); // Convert to PNG
            }
          };
        });
      };

      return {
        convertWebpToPng
      }
}